import useSWR from "swr";
import type { EntityRoster } from "@/lib/core/schemas/entity-roster";

const fetcher = async (url: string) => {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error("Failed to fetch entity roster");
  }
  return res.json();
};

export function useEntityRoster(campaignId: string | null, ids: string[]) {
  const key =
    campaignId && ids.length > 0
      ? `/api/campaigns/${campaignId}/entity-roster?ids=${[...new Set(ids)].sort().join(",")}`
      : null;

  const { data, error, isLoading, mutate } = useSWR<EntityRoster>(key, fetcher);

  return { roster: data, isLoading, error, mutate };
}
